import TabPanel from "../TabPanel";
import SubContractorManagement from "./SubContractorManagement";
import { SettingsModalTabProps } from "../types";

const SubContractorManagementTab: React.FC<SettingsModalTabProps> = ({ parentTab, index }) => {
  if (parentTab !== index) return;

  return (
    <TabPanel value={parentTab} index={index} paddingX={1} height={"calc(100vh - 110px)"}>
      <SubContractorManagement />
    </TabPanel>
  )
}
export default SubContractorManagementTab;
